import { render, staticRenderFns } from "./nothing-here.vue?vue&type=template&id=384633b4"
import script from "./nothing-here.vue?vue&type=script&lang=js"
export * from "./nothing-here.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384633b4')) {
      api.createRecord('384633b4', component.options)
    } else {
      api.reload('384633b4', component.options)
    }
    module.hot.accept("./nothing-here.vue?vue&type=template&id=384633b4", function () {
      api.rerender('384633b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/nothing-here.vue"
export default component.exports